import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const formatDateTimeLocal = (date = new Date()) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const HH = String(date.getHours()).padStart(2, "0");
    const ii = String(date.getMinutes()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd} ${HH}:${ii}`;
};
export const userOrder = create(persist(
    (set) => ({
        dataUser: {
            name: '',
            lastname: '',
            address: "No hay dirección",
            city: 0,
            city_name: "-",
            uuidShop: '',
            phone: '',
            type_document: '',
            dni_name: '',
            document: '',
            popAddress: true,
            deliveryMethod: 1,
            // PLZ-325: true cuando se entra por el boton "Pide y Recoge" (type_integration 2):
            // el flujo queda solo en recoger y no se ofrece domicilio.
            pickupOnly: false,
            shopData: [],
            dateDelivery: formatDateTimeLocal(),
        },
        setDataUser: (updatedFields) => set((state) => ({
            dataUser: {
                ...state.dataUser,
                ...updatedFields
            }
        })),
        resetDataOrder: () => set(() => ({
            dataUser: {
                name: '',
                lastname: '',
                address: "No hay dirección",
                city: 0,
                city_name: "-",
                uuidShop: '',
                phone: '',
                type_document: '',
                dni_name: '',
                document: '',
                deliveryMethod: 0,
                pickupOnly: false,
                shopData: [],
                dateDelivery: formatDateTimeLocal(),
            }
        }))
    }),
    {
        name: 'user-pleizt', // nombre para localStorage
    }
));
